import React, { useState, useRef, useEffect } from 'react';
import authService from 'services/auth.service';

const MiniLogin = ({updateUser, title}) => {
    const [email, setEmail] = useState('');
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [isVerifyingCode, setIsVerifyingCode] = useState(false);
    const [code, setCode] = useState(new Array(6).fill(''));
    const [errorMessage, setErrorMessage] = useState('');
    const inputRefs = useRef([]);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    useEffect(() => {
        if (isCodeSent) {
            inputRefs.current[0].focus();
        }
    }, [isCodeSent]);

    const handleEmailSubmit = (e) => {
        e.preventDefault();
        authService.sendCode(email);
        setIsCodeSent(true);
    };

    const handleCodeChange = (e, index) => {
        const newCode = [...code];
        newCode[index] = e.target.value;
        setCode(newCode);

        // Mover el foco al siguiente campo
        if (e.target.value && index < 5) {
            inputRefs.current[index + 1].focus();
        }

        // Si se ha introducido el último número, enviar el código al backend
        if (index === 5 && e.target.value) {
            handleCodeSubmit(newCode.join(''));
        }
    };

    const handleCodeSubmit = async (code) => {
        try {
            setIsVerifyingCode(true);
            await authService.loginWithCode(email, code);
            setErrorMessage(''); // Limpiar el mensaje de error si la autenticación es exitosa
        } catch (error) {
            setErrorMessage('Código incorrecto. Por favor, inténtalo de nuevo.');
        } finally {
            setIsVerifyingCode(false);
            updateUser();
        }
    };

    const handleCodeFormSubmit = (e) => {
        e.preventDefault();
        handleCodeSubmit(code.join(''));
    };

    const handlePaste = (e) => {
        const paste = e.clipboardData.getData('text');
        if (/^\d{6}$/.test(paste)) {
            const newCode = paste.split('');
            setCode(newCode);
            newCode.forEach((num, index) => {
                inputRefs.current[index].value = num;
            });
            inputRefs.current[5].focus();
            handleCodeSubmit(newCode.join(''));
        }
    };

    return (
        <div className='w-full justify-self-center p-6 bg-blueGray-50 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 flex flex-col items-center justify-center'>
            <h3 className='text-2xl font-bold text-center mb-4'>{title}</h3>
            {!isCodeSent ? (
                <div className='flex flex-row items-center justify-start h-full w-full'>
                    <form className="flex flex-col w-full" onSubmit={handleEmailSubmit}>
                        <div className="my-5 w-full flex items-center px-2 md:px-12">
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={handleEmailChange}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500"
                                placeholder="ejemplo@mail.com"
                                required
                            />
                            <button
                                type="submit"
                                className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 ml-4 rounded-lg"
                            >
                                <i className='fas fa-arrow-right text-lg'></i>
                            </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div className='flex flex-col items-center justify-center h-full w-full'>
                    <p className='text-lg text-center mb-4'>Introduce el código que hemos enviado a tu correo electrónico</p>
                    <form className="flex flex-row space-x-2" onSubmit={handleCodeFormSubmit}>
                        {code.map((digit, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleCodeChange(e, index)}
                                ref={(el) => (inputRefs.current[index] = el)}
                                onPaste={index === 0 ? handlePaste : null}
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-lg rounded-lg focus:ring-sky-500 focus:border-sky-500 block w-12 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-sky-500 dark:focus:border-sky-500 text-center"
                                required
                            />
                        ))}
                        <button
                            type="submit"
                            className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded-lg"
                        >
                            <i className={`fas ${isVerifyingCode ? 'fa-hourglass-half' : 'fa-arrow-right'} text-lg`}></i>
                        </button>
                    </form>
                    {errorMessage && (
                        <p className="text-red-500 mt-4">{errorMessage}</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default MiniLogin;